// import { createSlice } from "@reduxjs/toolkit";

// const initialState = {
//   FOB: [],
// };

// const FOBSlice = createSlice({
//   name: "FOB",
//   initialState,
//   reducers: {
//     updateFOB: (state, action) => {
//       const index = state.FOB.findIndex(
//         (item) => item.country === action.payload.country
//       );
//       if (index !== -1) {
//         state.FOB[index] = action.payload;
//       } else {
//         state.FOB.push(action.payload);
//       }
//     },
//   },
// });

// export const { updateFOB } = FOBSlice.actions;

// export default FOBSlice.reducer;

import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  FOB: [],
  loading: 'idle', // ✅ added new parameter
};

const FOBSlice = createSlice({
  name: "FOB",
  initialState,
  reducers: {
    updateFOB: (state, action) => {
      const index = state.FOB.findIndex(
        (item) => item.country === action.payload.country
      );
      if (index !== -1) {
        state.FOB[index] = action.payload;
      } else {
        state.FOB.push(action.payload);
      }
    },
    updateLoading: (state, action) => {
      state.loading = action.payload; // ✅ toggle/update loading
    },
  },
});

export const { updateFOB, updateLoading } = FOBSlice.actions;

export default FOBSlice.reducer;
